import { render, staticRenderFns } from "./Associations.vue?vue&type=template&id=33027468&scoped=true"
import script from "./Associations.vue?vue&type=script&lang=js"
export * from "./Associations.vue?vue&type=script&lang=js"
import style0 from "./Associations.vue?vue&type=style&index=0&id=33027468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33027468",
  null
  
)

export default component.exports